<template>
  <div>
    <h1 class="h3">
      {{ $t('product.listProduct') }}
    </h1>
    <div class="row mt-3">
      <div class="col-md-5">
        <a-input-search
          v-model="params.q"
          size="large"
          :placeholder="$t('store_list_page.search_products')"
          :loading="isLoading"
          :disabled="isLoading"
          allow-clear
          @search="onSearch"
        >
          <a-button slot="enterButton" type="danger" icon="search">
            {{ $t('utils.search') }}
          </a-button>
        </a-input-search>
      </div>
      <div class="col-md-3 p-0">
        <div class="d-flex align-items-center">
          <div class="flexno pr-2">
            {{ `${$t('order.sortBy')}:` }}
          </div>
          <a-select
            :default-value="sorting"
            size="large"
            class="select-antd-default ml-2"
            style="width: 220px"
            :placeholder="$t('product.sortProduct')"
            :options="options"
            :disabled="isLoading"
            @change="onSorting"
          />
        </div>
      </div>
      <div class="col-md-4 text-right">
        <a-tooltip :title="businessId?.includes(',') ? $t('product.selectFirst', { name: tooltipExportName }) : ''">
          <a-button
            v-if="businessId && permission.includes('WRITE')"
            type="primary"
            size="large"
            class="mr-3"
            ghost
            :disabled="isLoading || businessId?.includes(',')"
            @click="toPage('import')"
          >
            {{ $t('product.import') }}
          </a-button>
        </a-tooltip>
        <a-tooltip :title="businessId?.includes(',') ? $t('product.selectFirst', { name: tooltipExportName }) : ''">
          <a-button
            v-if="businessId && permission.includes('WRITE')"
            type="primary"
            size="large"
            :disabled="isLoading || businessId?.includes(',')"
            @click.prevent="toPage('create')"
          >
            {{ $t('product.addProduct') }}
          </a-button>
        </a-tooltip>
      </div>
    </div>
    <div class="mt-3">
      <a-tabs class="pca-tab-product" :disabled="isLoading" @change="onTabChange">
        <a-tab-pane v-for="tab in tabs" :key="tab.value" :tab="tab.label" />
        <a-dropdown slot="tabBarExtraContent">
          <a-menu slot="overlay">
            <a-menu-item
              key="1"
              :disabled="businessId?.includes(',')"
              @click="exportMaster"
            >
              {{ $t('sideBar.product_master') }}
            </a-menu-item>
            <a-menu-item
              key="2"
              :disabled="businessId?.includes(',')"
              @click="exportAllocation"
            >
              {{ $t('product.stock_allocation') }}
            </a-menu-item>
          </a-menu>
          <a-button type="primary" :loading="isLoading || isLoadingExport" class="ml-2">
            {{ $t('warehouse.export_data') }} <a-icon type="down" />
          </a-button>
        </a-dropdown>
      </a-tabs>
      <a-table
        class="master-list"
        :data-source="products"
        :row-key="(record) => record.id"
        :columns="columns"
        :expand-icon-as-cell="false"
        :expand-icon-column-index="0"
        :loading="isLoading"
        :pagination="false"
        :scroll="scroll"
      >
        <span slot="customDetail">
          <a-checkbox
            v-if="$route.query.business_id"
            v-model="checkAll"
            class="mr-2"
            :indeterminate="indeterminate"
            @change="onCheckAll"
          />
          <span>{{ $t('product.product_name') }}</span>
        </span>
        <div slot="expandIcon" slot-scope="props" class="d-flex align-items-center">
          <div>
            <a-checkbox v-if="$route.query.business_id" v-model="props.record.checked" class="mr-3" @change="onChangeCheckBox($event, props.record)" />
          </div>
          <div style="cursor: pointer" @click="toPage('edit', props.record.id)">
            <PcaImage
              width="54"
              height="54"
              :src="`${props.record.showimg_url || $defaultImage}?tr=w-100,h-100,cm-pad_resize,bg-FFFFFF`"
              :alt="props.record.title"
              class="product-image mr-3 flexno of-contain"
            />
          </div>
          <div>
            <p class="master-brand">
              {{ getBrandName(props.record) }}
            </p>
            <a-tooltip v-if="props.record.title && props.record.title.length > 41" placement="top">
              <template slot="title">
                <span>{{ props.record.title }}</span>
              </template>
              <p class="master-title" style="cursor: pointer" @click="toPage('edit', props.record.id)">
                {{ `${props.record.title.substring(0, 41)}...` }}
              </p>
            </a-tooltip>
            <p v-else class="master-title" style="cursor: pointer" @click="toPage('edit', props.record.id)">
              {{ props.record.title || '-' }}
            </p>
            <p class="master-sku">
              <span v-if="+props.record.variant_count > 1" @click="e => onOpen(props, e)">
                {{ $t(`product.${props.record.isOpen ? 'close_variant' : 'view_variant'}`) }}
              </span>
              <template v-else>
                {{ $t('productAvailability.sku') }}: {{ props.record.catalogs?.[0]?.sku || '-' }}
              </template>
            </p>
          </div>
        </div>
        <template slot="category" slot-scope="text">
          {{ text?.name || '-' }}
        </template>
        <template slot="status" slot-scope="text">
          <a-tag :color="colors[text]" class="w-100">
            {{ $t(`store_list_page.${text.toLowerCase()}`) }}
          </a-tag>
        </template>
        <template slot="action" slot-scope="record">
          <div class="text-right">
            <a-dropdown v-if="permission.includes('READ') || permission.includes('WRITE')">
              <a @click.prevent="">
                <a-icon type="more" />
              </a>
              <template #overlay>
                <a-menu>
                  <a-menu-item
                    v-if="$route.query.business_id && permission.includes('READ')"
                    key="1"
                    class="py-2"
                    @click="toPage('edit', record.id)"
                  >
                    <a-icon type="eye" class="mr-2" />
                    {{ $t('product.detail') }}
                  </a-menu-item>
                  <a-menu-item
                    v-if="$route.query.business_id && permission.includes('READ') && !params.is_draft"
                    key="2"
                    class="py-2"
                    @click="toPage('allocation', record.id)"
                  >
                    <a-icon type="container" class="mr-2" />
                    {{ $t('product.stock_allocation') }}
                  </a-menu-item>
                  <a-menu-item
                    v-if="isSuperAdmin && $route.query.business_id && permission.includes('WRITE') && params.is_draft"
                    key="3"
                    class="py-2"
                    @click="activateProduct(record.id)"
                  >
                    <a-icon type="container" class="mr-2" />
                    {{ $t('store_list_page.activate_product') }}
                  </a-menu-item>
                  <a-menu-item
                    v-if="isSuperAdmin && $route.query.business_id && permission.includes('WRITE')"
                    key="4"
                    class="py-2"
                    @click="republishProductMaster(record.id)"
                  >
                    <a-icon type="container" class="mr-2" />
                    {{ $t('product.republish_product') }}
                  </a-menu-item>
                  <a-menu-item
                    v-if="isSuperAdmin && $route.query.business_id && permission.includes('WRITE')"
                    key="5"
                    class="py-2"
                    @click="showConfirm(record.id, record.title)"
                  >
                    <a-icon type="delete" class="mr-2" />
                    {{ $t('product.delete') }}
                  </a-menu-item>
                </a-menu>
              </template>
            </a-dropdown>
          </div>
        </template>
        <div v-if="text.catalogs.length > 1" slot="expandedRowRender" slot-scope="text">
          <table class="catalog-list">
            <thead>
              <tr style="border: 1px solid #e4e9f0">
                <th>{{ $t('product.picture') }}</th>
                <th>{{ $t('utils.sku') }}</th>
                <th v-for="(option, index) in Object.keys(text.catalogs[0].options)" :key="index">
                  {{ option }}
                </th>
                <th>{{ $t('product.price') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="catalog in text.catalogs" :key="catalog.id" style="border: 1px solid #e4e9f0">
                <td>
                  <PcaImage
                    width="40"
                    height="40"
                    :src="`${catalog.image_url?.[0]?.imagePath || $defaultImage}?tr=w-100,h-100,cm-pad_resize,bg-FFFFFF`"
                    :alt="catalog.title"
                    class="product-image mr-3 flexno of-contain"
                  />
                </td>
                <td>
                  {{ catalog?.sku || '-' }}
                </td>
                <td v-for="(option, index) in Object.keys(text.catalogs[0].options)" :key="index">
                  {{ catalog.options[option] }}
                </td>
                <td>
                  {{ catalog?.price || '-' }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </a-table>
    </div>
    <div class="pagination-wrapper">
      <div>
        <a-button
          v-if="isSuperAdmin && $route.query.business_id"
          type="primary"
          :disabled="!selectedProducts.length"
          @click="republishMultiProductMaster"
        >
          {{ $t('product.republish_multi_product') }}
        </a-button>
        <a-button
          v-if="showButton && $route.query.business_id"
          type="primary"
          class="ml-3"
          :disabled="!selectedProducts.length"
          @click="toggleModalImport(true)"
        >
          {{ $t('product.bulk_edit_product') }}
        </a-button>
      </div>
      <a-pagination
        v-model="params.page"
        :page-size="params.limit"
        :page-size-options="sizeOptions"
        :total="total_row"
        :show-total="(total, range) => $t('utils.pagination_show_total', { perpage: `${range[0]} - ${range[1]}`, total })"
        :disabled="isLoading"
        show-size-changer
        :locale="{ items_per_page: $t('utils.items_per_page') }"
        @change="onPageChange"
        @showSizeChange="onShowSizeChange"
      />
    </div>

    <a-modal
      v-model="showModalImport"
      :width="380"
      :dialog-style="{ top: '30px' }"
      :closable="false"
      :title="`${$t('product.bulk_edit_product')} ${params.is_variant ? 'Variant' : 'Non Variant'}`"
    >
      <template slot="footer">
        <a-button
          key="back"
          :disabled="downloading || uploading"
          @click="fileList = []; toggleModalImport(false)"
        >
          {{ $t('utils.close') }}
        </a-button>
        <a-button
          key="submit"
          type="primary"
          :loading="uploading"
          :disabled="fileList.length < 1 || downloading || uploading"
          @click="handleUpload"
        >
          {{ $t('manualOrder.upload_file') }}
        </a-button>
      </template>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-spin :spinning="downloading">
            <button
              class="avatar-uploader ant-upload-picture-card-wrapper btn-download"
              :disabled="downloading || uploading"
              @click="downloadTemplate"
            >
              <div class="ant-upload ant-upload-select ant-upload-select-picture-card">
                <span role="button" tabindex="0" class="ant-upload">
                  <div>
                    <a-icon type="download" />
                    <div class="ant-upload-text">
                      Download Template
                    </div>
                  </div>
                </span>
              </div>
            </button>
          </a-spin>
        </a-col>
        <a-col :span="12">
          <a-spin :spinning="uploading">
            <a-upload
              name="avatar"
              list-type="picture-card"
              class="avatar-uploader"
              :file-list="fileList"
              :remove="handleRemove"
              :before-upload="beforeUpload"
              :disabled="downloading || uploading"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            >
              <div v-if="fileList.length < 1">
                <a-icon :type="uploading ? 'loading' : 'plus'" />
                <div class="ant-upload-text">
                  {{ $t('product.upload_bulk_edit_product') }}
                </div>
              </div>
            </a-upload>
          </a-spin>
        </a-col>
      </a-row>
      <div v-if="errorList.length" class="tbl-error">
        <table>
          <thead>
            <tr>
              <th>Keterangan</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(err, index) in errorList" :key="index">
              <td>{{ err }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </a-modal>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import { getPriceRange } from '@/api/price'
import { useCurrency } from '@/composable/useCurrency'

import PcaImage from '@/components/Image'
import XLSX from 'xlsx';
import {
  getProductMasterList,
  exportProductMaster,
  checkRequestExportProductMaster,
  productPublish, republishProduct,
  getTotalProductChannelAllocation,
  deleteProduct,
  downloadBulkEditFile,
  uploadBulkEditFile,
} from '@/api/product'
import {
  getInventoryListV2,
  getTotalInventoryMovement,
  exportProductAllocation,
  checkRequestExportProductAllocation,
  downloadProductAllocation,
} from '@/api/inventory'

const { format } = useCurrency()

export default {
  components: {
    PcaImage,
  },
  data() {
    return {
      screenHeight: 'calc(100vh - 400px)',
      isLoading: false,
      indeterminate: false,
      checkAll: false,
      showModalImport: false,
      downloading: false,
      uploading: false,
      showButton: false,
      sorting: 'createdAt.desc',
      activeKey: 'all',
      total_row: 0,
      params: {
        q: '',
        page: 1,
        limit: 10,
        sortBy: 'createdAt',
        sortDir: 'desc',
        is_variant: undefined,
        is_bundling: undefined,
        is_draft: undefined,
      },
      colors: {
        ACTIVE: 'blue',
        NOT_ACTIVE: 'red',
        INACTIVE: 'red',
      },
      products: [],
      selectedProducts: [],
      fileList: [],
      errorList: [],
      sizeOptions: ['10', '20', '30', '40', '50'],
      whiteList: ['1a5e240b-535d-45c7-9646-b19b2047daa2', '30d9817c-07ef-45b8-a36c-319f86734b29', 'b7575f5b-1b45-4f53-b3fa-fccc9f7f1a42'],
    }
  },
  computed: {
    isSuperAdmin() {
      return this.$store.state.user.role_name === 'Super User'
    },
    tooltipExportName() {
      return this.$store.state.user.restriction_base.toLowerCase() === 'warehouse' ? this.$t('fulfillment.warehouse') : this.$t('fulfillment.business')
    },
    columns() {
      return [
        {
          dataIndex: 'detail',
          key: 'detail',
          width: 450,
          slots: { title: 'customDetail' },
          scopedSlots: {
            customRender: 'detail',
          },
        },
        {
          title: this.$t('product.categories'),
          dataIndex: 'category',
          key: 'category',
          width: 150,
          scopedSlots: {
            customRender: 'category',
          },
        },
        {
          title: this.$t('product.varian'),
          dataIndex: 'variant_count',
          key: 'variant_count',
          align: 'center',
          width: 100,
        },
        {
          title: this.$t('product.range_price'),
          dataIndex: 'price',
          key: 'price',
          width: 220,
          scopedSlots: {
            customRender: 'price',
          },
        },
        {
          title: this.$t('product.status'),
          dataIndex: 'status',
          key: 'status',
          width: 120,
          align: 'center',
          scopedSlots: {
            customRender: 'status',
          },
        },
        {
          title: '',
          key: 'action',
          width: 50,
          scopedSlots: {
            customRender: 'action',
          },
        },
      ]
    },
    tabs() {
      const defaultTabs = [
        { value: 'all', label: this.$t('utils.all') },
        { value: 'nonvariant', label: this.$t('product.nonVariant') },
        { value: 'variant', label: this.$t('product.varian') },
        { value: 'bundling', label: this.$t('product.bundling') },
      ]
      if (this.isSuperAdmin) {
        defaultTabs.push({ value: 'draft', label: this.$t('product.draft') })
      }
      return defaultTabs
    },
    options() {
      return [
        { value: 'createdAt.desc', label: this.$t('product.new_product') },
        { value: 'createdAt.asc', label: this.$t('product.old_product') },
        { value: 'title.asc', label: `${this.$t('product.product_name')} (A - Z)` },
        { value: 'title.desc', label: `${this.$t('product.product_name')} (Z - A)` },
      ]
    },
    businessId() {
      if ((this.$store.state.user.restriction_base.toLowerCase() === 'business' && !this.$route.query.business_id) || (this.$store.state.user.restriction_base.toLowerCase() === 'warehouse' && !this.$route.query.warehouse_id)) {
        const arrBusinessID = Object.keys(this.$store.getters['user/businessListObjectByKey'])
        return arrBusinessID.join(',')
      }
      if (this.$store.state.user.restriction_base.toLowerCase() === 'warehouse' && this.$route.query.warehouse_id) {
        const findBusinessIdByWhsId = this.$store.state.user.businessList?.find((obj) => obj.warehouse_id === this.$route.query.warehouse_id)
        if (findBusinessIdByWhsId) {
          return findBusinessIdByWhsId.business_id
        }
      }
      return this.$store.state.user.restriction_base === 'Warehouse'
        ? Object.keys(this.$store.getters['user/businessListObjectByKey'])[0]
        : this.$route.query.business_id
    },
    scroll() {
      return { y: 'calc(100vh - 400px)', x: 1000 }
    },
    tHeight() {
      return !this.products.length ? '0px' : 'calc(100vh - 400px)'
    },
    permission() {
      return this.$store.getters['user/can'](this.$route.meta.key)
    },
    isLoadingExport() {
      return this.$store.state.exportData.loadingExport
    },
  },
  watch: {
    '$store.state.products.products'(value) {
      this.fetchPrice(value)
    },
    '$route.query'() {
      this.init()
    },
    businessId() {
      this.init()
    },
    // permission(newValue) {
    //   if(!newValue.length) this.$router.push({ path: '/error/403', query: { ...this.$route.query } })
    // },
  },
  mounted() {
    this.init()
  },
  methods: {
    showConfirm(productId, productName) {
      this.$confirm({
        title: this.$t('product.delete_product_confirm_title'),
        content: this.$t('product.delete_product_confirm_content', { name: productName }),
        onOk: () => this.fetchProductMovementAndChannel(productId, productName),
        onCancel() {},
      });
    },
    init: debounce(function () {
      this.fetchProducts()
    }, 500),
    async fetchProductMovementAndChannel(productId, productName) {
      this.isLoading = true
      const payload = {
        business_id: this.businessId,
        params: {
          product_id: productId,
        },
      }
      await Promise.all([getTotalInventoryMovement(payload), getTotalProductChannelAllocation(payload)])
      .then(async ([{ data: totalMovement }, { data: totalChannel }]) => {
        if (!totalMovement && !totalChannel) {
          await deleteProduct({
            business_id: this.businessId,
            product_id: productId,
          })
          .then(() => {
            this.$notification.success({
              message: 'Produk Berhasil di Hapus',
              description: `Produk ${productName} berhasil di hapus`,
            })
            this.fetchProducts()
          })
          .catch(() => {
            this.$notification.error({
              message: 'Produk Gagal di Hapus',
              description: 'Produk gagal di hapus, mohon hubungi Admin',
            })
            this.isLoading = false
          })
        } else {
          const desc = totalMovement && !totalChannel
            ? 'Movement'
            : !totalMovement && totalChannel
            ? 'Alokasi Channel'
            : 'Movement dan Alokasi Channel'
          this.$notification.warning({
            message: `Produk ${message} di Hapus`,
            description: `Terdapat ${desc} pada produk ${productName}`,
          })
          this.isLoading = false
        }
      })
      .catch(() => {
        this.$notification.error({
          message: 'Produk Gagal di Hapus',
          description: 'Produk gagal di hapus, mohon hubungi Admin',
        })
        this.isLoading = false
      })
    },
    async fetchProducts() {
      this.isLoading = true
      this.total_row = 0
      await this.$store
        .dispatch('products/GETPRODUCTLISTMASTER', {
          ...this.params,
          q: !this.params.q ? undefined : this.params.q,
          workspace_id: this.$route.query.workspace_id,
          business_id: this.businessId,
          warehouse_id: this.$route.query.warehouse_id,
        })
        .then(({ total_row }) => this.total_row = +total_row || 0)
        .catch(() => this.isLoading = false)
    },
    async fetchPrice(products) {
      this.isLoading = true
      this.products = products && products.length
        ? await Promise.all(products.map(async (product) => {
          const price = await this.getProductPrice(product?.business_id, product.id)
          product.isOpen = false
          product.price = price.range || '-'
          product.checked = false
          product.catalogs.forEach(catalog => {
            const catalogPrice = price.list.find(p => p.catalog_id === catalog.id)
            catalog.price = catalogPrice?.price
              ? format(catalogPrice.price, 'IDR')
              : '-'
            catalog.price = catalog.price.replace('Rp', catalogPrice?.currency || 'IDR')
          })
          return product
        }))
        : []
      this.isLoading = false
    },
    async getProductPrice(business_id, product_id) {
      return await getPriceRange({
        business_id: business_id || this.businessId,
        product_id,
      })
        .then(({ data: { data } }) => {
          let obj = {
            list: [],
            range: null,
          }

          if (data?.length) {
            let tmpPrices = [Infinity, -Infinity]
            data.forEach(({ catalog_id, price: catalogPrices }) => {
              obj.list.push({
                catalog_id,
                price: catalogPrices[0].value,
                uom: catalogPrices[0].uom,
                currency: catalogPrices[0].currency,
              })
              catalogPrices.forEach(price => {
                tmpPrices[0] = Math.min(tmpPrices[0], price.value)
                tmpPrices[1] = Math.max(tmpPrices[1], price.value)
              })
            })

            obj.range = tmpPrices[0] == tmpPrices[1]
              ? format(tmpPrices[0], 'IDR')
              : `${format(tmpPrices[0], 'IDR')} - ${format(tmpPrices[1], 'IDR')}`
            
            obj.range = obj.range.replace('Rp', obj.list?.[0]?.currency || 'IDR')
          }
          return obj
        })
        .catch(() => {
          return {
            list: [],
            range: null,
          }
        })
    },
    async activateProduct(id) {
      this.isLoading = true
      await productPublish({
        id,
        business_id: this.businessId,
      })
      .then(() => {
        this.$notification.success({ message: this.$t('product.activationSuccess') })
        this.fetchProducts()
      })
      .catch((err) => {
        this.$notification.error({
          message: this.$t('product.activationFailed'),
          description: err.response?.data?.message || err.message,
        })
        this.isLoading = false
      })
    },
    async republishProductMaster(product_id) {
      this.isLoading = true
      await republishProduct({
        business_id: this.businessId,
        params: { product_id },
      })
      .then(() => this.$notification.success({ message: this.$t('product.republishSuccess') }))
      .catch((err) => {
        this.$notification.error({
          message: this.$t('product.republishFailed'),
          description: err.response?.data?.message || err.message,
        })
      })
      .finally(() => this.isLoading = false)
    },
    async republishMultiProductMaster() {
      if (this.selectedProducts.length) {
        this.isLoading = true
        await republishProduct({
          business_id: this.businessId,
          params: { product_id: this.selectedProducts.join() },
        })
        .then(() => {
          this.onCheckAll({ target: { checked: false} })
          this.$notification.success({ message: this.$t('product.republishSuccess') })
        })
        .catch((err) => {
          this.$notification.error({
            message: this.$t('product.republishFailed'),
            description: err.response?.data?.message || err.message,
          })
        })
        .finally(() => this.isLoading = false)
      }
    },
    getBrandName(product) {
      const brand = this.$store.getters['user/businessListObjectByKey'][product.business_id] || null
      return brand?.business_title || null
    },
    onSearch() {
      this.onCheckAll({ target: { checked: false} })
      this.params.page = 1
      this.fetchProducts()
    },
    onSorting(value) {
      this.onCheckAll({ target: { checked: false} })
      const [sortBy, orderBy] = value.split('.')
      this.params.sortBy = value !== 'createdAt.desc'
        ? sortBy
        : undefined
      this.params.sortDir = value !== 'createdAt.desc'
        ? orderBy
        : undefined
      this.fetchProducts()
    },
    onTabChange(tab) {
      this.onCheckAll({ target: { checked: false} })
      this.params.is_variant = tab === 'nonvariant' || tab === 'bundling'
        ? false
        : tab === 'variant'
        ? true
        : undefined
      this.params.is_bundling = tab === 'bundling'
        ? true
        : undefined
      this.params.is_draft = tab === 'draft'
        ? true
        : undefined
      this.params.page = 1
      this.showButton = tab === 'nonvariant' || tab === 'variant' || tab === 'bundling'
      this.fetchProducts()
    },
    onPageChange(pageNumber) {
      this.onCheckAll({ target: { checked: false} })
      this.params.page = pageNumber
      this.fetchProducts()
    },
    onShowSizeChange(current, pageSize) {
      this.onCheckAll({ target: { checked: false} })
      this.params.page = current
      this.params.limit = pageSize
      this.fetchProducts()
    },
    onChangeCheckBox(event, record) {
      let countChecked = 0
      this.products = this.products.map(item => {
        const checked = item.id === record.id
          ? event.target.checked
          : item.checked
        if (checked) countChecked++
        return {
          ...item,
          checked,
        }
      })
      this.checkAll = this.products.length && this.products.length == countChecked
      this.indeterminate = !this.checkAll && countChecked > 0
      const selectedProductIndex = this.selectedProducts.findIndex(item => item === record.id)
      if (event.target.checked && selectedProductIndex < 0) {
        this.selectedProducts.push(record.id)
      } else if (!event.target.checked && selectedProductIndex > -1) {
        this.selectedProducts.splice(selectedProductIndex, 1)
      }
    },
    onCheckAll(event) {
      this.selectedProducts = []
      this.indeterminate = false
      this.products = this.products.map(item => {
        if (event.target.checked) {
          this.selectedProducts.push(item.id)
        } else {
          this.checkAll = false
        }

        return {
          ...item,
          checked: event.target.checked,
        }
      })
    },
    onOpen(props, event) {
      props.record.isOpen = !props.record.isOpen
      props.onExpand(props.record, event)
    },
    checkIsWarehouseRestrictionAllowed(product_id = undefined) {
    },
    async toPage(page, product_id = undefined) {
      this.isLoading = true
      const promiseCheck = new Promise((resolve, reject) => {
        if (this.$store.state.user.restriction_base === 'Warehouse' && page === 'edit') {
          let findRestrictionList = this.$store.state.user.user_workspaces.find((obj) => obj.workspace_id === this.$route.query.workspace_id)
          if (findRestrictionList?.restriction_list?.length > 0) {
            let bodyValue = {
              business_id: this.businessId,
              product_id: product_id,
            }
            getInventoryListV2(bodyValue)
              .then(({ data }) => {
                this.isLoading = false
                data.forEach((obj) => {
                  if (findRestrictionList.restriction_list.includes(obj.warehouse_id)) {
                    resolve(true)
                  }
                })
                resolve(false)
              })
              .catch(err => {
                console.error(err)
                resolve(false)
              })
          }
        } else {
          resolve(true)
        }
      })
      const isAllowed = await promiseCheck
      if (isAllowed) {
        this.$router.push({
          name: `product.${page}`,
          params: {
            id: product_id,
          },
          query: {
            workspace_id: this.$route.query.workspace_id,
            business_id: this.$route.query.business_id,
            warehouse_id: this.$route.query.warehouse_id,
            id: product_id,
            redirect_url: page === 'create'
              ? this.$route.fullPath
              : undefined,
          },
        })
      } else {
        this.$notification.error({
          message: this.$t('product.accessDenied'),
          description: this.$t('product.accessDeniedDesc', { page }),
        })
      }
    },
    normalizeObjectKeyToLabel(text) {
      const result = text.replace(/([A-Z])/g, " $1");
      return result.charAt(0).toUpperCase() + result.slice(1);
    },
    async exportAllocation() {
      if (this.businessId) {
        this.$store.commit('exportData/SET_STATE_EXPORT_DATA', {
          showModalExportSales: true,
          loadingExport: true,
        })

        await exportProductAllocation(this.businessId)
        .then(({ data }) => this.onResponseExportAllocation(data))
        .catch(() => this.onErrorExportAllocation())
      }
    },
    async exportMaster() {
      if (this.businessId) {
        this.$store.commit('exportData/SET_STATE_EXPORT_DATA', {
          showModalExportSales: true,
          loadingExport: true,
        })

        await exportProductMaster(this.businessId)
        .then(({ data }) => this.onResponseExportMaster(data))
        .catch(() => this.onErrorExportMaster())
      }
    },
    getProcessExportAllocation: debounce(async function(request_id) {
      await checkRequestExportProductAllocation({
        business_id: this.businessId,
        request_id,
      })
      .then(({ data }) => this.onResponseExportAllocation(data))
      .catch(() => this.onErrorExportAllocation())
    }, 10000),
    getProcessExportMaster: debounce(async function(request_id) {
      await checkRequestExportProductMaster({
        request_id,
        params: {
          process_name: 'EXPORT_EXCEL',
        },
      })
      .then(({ data }) => this.onResponseExportMaster(data))
      .catch(() => this.onErrorExportMaster())
    }, 10000),
    async exportDataTable() {
      if (this.businessId) {
        const payload = {
          workspace_id: this.$route.query.workspace_id,
          business_id: this.businessId,
          page: 1,
          limit: this.total_row,
        }
        this.$store.commit('exportData/SET_STATE_EXPORT_DATA', {
          showModalExportSales: true,
          loadingExport: true,
        })
        await getProductMasterList({
          business_id: this.businessId,
          params: payload,
        })
        .then(async ({ data: { data: response } }) => {
          const flattenData = []
          let numbering = 0
          if (!response.length > 0) return
          await Promise.all(response.map(async (obj, idx) => {
            const price = await this.getProductPrice(obj.id)
            let flattenItem = {
              productId: obj.id,
              catalogId: '',
              noSku: '',
              noSkuPabrik: '',
              kategori: obj?.category?.name || '',
              namaProduk: '',
              'fotoProduk 1': obj?.showimg_url || '',
              'fotoProduk 2': '',
              'fotoProduk 3': '',
              'fotoProduk 4': '',
              'fotoProduk 5': '',
              opsiVarian: '',
              tipeVarian: '',
              fotoVarian: '',
              mataUang: '',
              harga: '',
              uom: '',
              detail: obj?.long_description
                ? obj.long_description.replace(/(<([^>]+)>)/ig, '')
                : '',
            }
            if (obj.catalogs.length > 0) {
              obj.catalogs.forEach(catalog => {
                numbering += 1
                let currentType = ''
                let currentOption = ''
                let currentImageUrl = ''
                if (catalog.options) {
                  Object.entries(catalog.options).forEach(([key, value]) => {
                    currentType = value
                    currentOption = key
                  })
                }
                if (catalog.image_url?.length > 0) {
                  currentImageUrl = catalog.image_url.at(0)?.imagePath
                }
                const catalogPrice = price?.list?.find(p => p.catalog_id === catalog.id)
                const newFlattenItem = {
                  catalogId: catalog.id,
                  namaProduk: catalog?.title,
                  opsiVarian: currentOption,
                  tipeVarian: currentType,
                  fotoVarian: currentImageUrl || '',
                  noSku: catalog?.sku,
                  noSkuPabrik: catalog?.factory_sku || '',
                  mataUang: catalogPrice?.currency || '',
                  harga: catalogPrice?.price || 0,
                  uom: catalogPrice?.uom || '',
                }
                flattenData.push({
                  no: numbering,
                  ...flattenItem,
                  ...newFlattenItem,
                })
              })
            } else {
              numbering += 1
              flattenData.push({
                no: numbering,
                ...flattenItem,
              })
            }
          }))
          const rowData = []
          const sampleData = flattenData.at(0)
          Object.keys(sampleData).forEach((obj) => {
            if (obj !== 'index') {
              rowData.push(this.normalizeObjectKeyToLabel(obj))
            }
          })
          const worksheet = XLSX.utils.json_to_sheet(flattenData);
          const workbook = XLSX.utils.book_new()
          XLSX.utils.sheet_add_aoa(worksheet, [rowData], { origin: "A1" });
          XLSX.utils.book_append_sheet(workbook, worksheet, 'data')
          XLSX.writeFile(workbook, 'data_product.xlsx')

          this.$notification.success({
            message: this.$t('product.exportSuccess'),
          })
        })
        .catch(() => this.isLoading = false)
        .finally(() => {
          this.$store.commit('exportData/SET_STATE_EXPORT_DATA', {
            exportFileNotification: false,
            showModalExportSales: false,
            loadingExport: false,
          })
        })
      }
    },
    onResponseExportAllocation(data) {
      if (data?.status === 'FAILED') {
        this.onErrorExportAllocation()
      } else if (data?.status === 'COMPLETED') {
        this.$store.commit('exportData/SET_STATE_EXPORT_DATA', {
          exportFileNotification: false,
          showModalExportSales: false,
          loadingExport: false,
        })
        this.downloadExportProductAllocation(data?.requestId)
      } else {
        this.getProcessExportAllocation(data?.requestId || data?.request_id)
      }
    },
    onResponseExportMaster(data) {
      if (data?.status === 'FAILED') {
        this.onErrorExportMaster()
      } else if (data?.status === 'FINISHED') {
        this.$store.commit('exportData/SET_STATE_EXPORT_DATA', {
          exportFileNotification: false,
          showModalExportSales: false,
          loadingExport: false,
        })
        if (data?.url) {
          window.location.href = data.url
        }
      } else {
        this.getProcessExportMaster(data.request_id)
      }
    },
    onErrorExportAllocation() {
      this.$store.commit('exportData/SET_STATE_EXPORT_DATA', {
        exportFileNotification: false,
        showModalExportSales: false,
        loadingExport: false,
      })
      this.$notification.error({
        message: this.$t('product.exportFailed'),
        description: this.$t('product.exportFailedAllocation'),
      })
    },
    onErrorExportMaster() {
      this.$store.commit('exportData/SET_STATE_EXPORT_DATA', {
        exportFileNotification: false,
        showModalExportSales: false,
        loadingExport: false,
      })
      this.$notification.error({
        message: this.$t('product.exportFailed'),
        description: this.$t('product.exportFailedDesc'),
      })
    },
    async downloadExportProductAllocation(request_id) {
      await downloadProductAllocation({
        business_id: this.businessId,
        request_id,
      })
      .then(({ data }) => {
        const findBusiness = this.$store.state.user?.businessList?.find(business => business.business_id === this.businessId)
        const url = window.URL.createObjectURL(new Blob([data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `productmaster_allocationstatus_${this.$moment().format('MMDDYYYY')}.xlsx`)
        document.body.appendChild(link)
        link.click()
        link.remove()
      })
      .catch(err => {
        this.$notification.error({
          message: this.$t('transferStock.buttons.import.notifications.downloadTemplateError'),
          description:
            err?.message || this.$t('transferStock.buttons.import.notifications.downloadTemplateDesc'),
        })
      })
    },
    toggleModalImport(value) {
      this.showModalImport = value
      this.errorList = []
    },
    async downloadTemplate() {
      this.downloading = true
      await downloadBulkEditFile({
        business_id: this.businessId,
        data: { product_ids: this.selectedProducts },
        params: {
          is_variant: this.params.is_variant,
          is_bundling: !!this.params.is_bundling,
        },
      })
      .then(res => {
        if (res?.data) {
          const a = document.createElement('a')
          a.href = window.URL.createObjectURL(res.data)
          a.download = this.params.is_variant
            ? 'Template_Edit_Variant.xlsx'
            : this.params.is_bundling
            ? 'Template_Edit_Bundling.xlsx'
            : 'Template_Edit_Non_Variant.xlsx'
          document.body.appendChild(a)
          a.click()
          setTimeout(() => {
            a.remove()
          }, 9)
        }
      })
      .catch(err => console.error(err))
      .finally(() => this.downloading = false)
    },
    async handleUpload() {
      this.uploading = true
      await uploadBulkEditFile({
        business_id: this.businessId,
        file: this.fileList[0],
        product_ids: this.selectedProducts,
        is_variant: this.params.is_variant,
        is_bundling: !!this.params.is_bundling,
      })
      .then(({ data: response }) => {
        if (response?.status === 'success') {
          this.fileList = []
          this.errorList = []
          this.$notification.success({
            message: 'Upload Berhasil',
            description: 'Data berhasil di upload. Silahkan refresh data secara berkala',
          })
          this.toggleModalImport(false)
          this.onCheckAll({ target: { checked: false} })
          this.fetchProducts()
        } else {
          this.$notification.error({ message: 'Upload Gagal' })
          this.errorList = response?.message || []
        }
      })
      .catch(err => {
        this.$notification.error({
          message: 'Upload Gagal',
          description: err.response?.data?.message || err.message,
        })
      })
      .finally(() => this.uploading = false)
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file)
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = newFileList
      this.errorList = []
    },
    beforeUpload(file) {
      this.fileList = [...this.fileList, file]
      this.errorList = []
      return false
    },
  },
}
</script>

<style lang="scss">
.select-antd-default.ant-select-lg .ant-select-selection__rendered {
  line-height: 38px !important;
}

.master-list div.ant-table-body {
  max-height: calc(100vh - 400px) !important;
  min-height: auto !important;
}

.catalog-list {
  border: 1px solid #e4e9f0;

  tr>th {
    padding: 10px;
    font-weight: 500;
    background-color: #f8f9fa;
  }

  tr>td {
    padding: 5px 10px;
    background-color: #fff;
  }

  tr>th,
  tr>td {
    border-bottom: 1px solid #e4e9f0;
  }
}

.master-brand {
  font-size: 10px;
  font-weight: bold;
  color: #888
}

.master-title {
  font-weight: 500;
  color: #ff0a54;
}

.master-sku {
  font-size: 12px;

  span {
    font-weight: 600;
    color: #2196F3;
    cursor: pointer
  }
}

.master-brand,
.master-title,
.master-sku {
  margin: 0;
}

.pca-tab-product {
  .ant-tabs-nav .ant-tabs-tab:hover,
  .ant-tabs-nav .ant-tabs-tab-active {
    color: #ff0a54;
  }

  .ant-tabs-ink-bar {
    background-color: #ff0a54;
  }
}

.pagination-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1rem;
}

.avatar-uploader > .ant-upload,
.ant-upload-list-picture-card-container,
.ant-upload-list-picture-card .ant-upload-list-item {
  width: 150px !important;
  height: 150px !important;
  margin: 0 !important;
}

.ant-upload-select-picture-card i {
  font-size: 32px !important;
  color: #999 !important;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px !important;
  color: #666 !important;
}

.ant-upload-list-item-name {
  white-space: inherit !important;
}

.ant-upload-list-picture-card .ant-upload-list-item-thumbnail {
  font-size: 48px !important;
}

.ant-upload-list-picture-card .ant-upload-list-item-actions i {
  width: 24px !important;
  font-size: 24px !important;
}

.btn-download {
  margin: 0;
  padding: 0;
  border: none;

  .ant-upload {
    width: 100% !important;
  }
}

.btn-download:disabled div,
.btn-download[disabled] div,
.btn-download:disabled span,
.btn-download[disabled] span {
  cursor: not-allowed;
}

.tbl-error {
  max-height: 400px;
  margin-top: 10px;
  overflow: auto;

  table {
    width: 100%;
    border-collapse: collapse;
  }

  thead th {
    position: sticky;
    top: 0;
    background: #fff1f0;
    z-index: 1;
  }

  th, td {
    padding: 5px;
    border: 1px solid #ffa39e;
  }
}
</style>
